/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scope: NonNullable<unknown> }} Audit_Details_Trust_Window_Revoke_DescInputs */



/**
* | output |
* | --- |
* | "A tool trust window was closed ({scope}), so matching tool calls ask for confirmation again." |
*
* @param {Audit_Details_Trust_Window_Revoke_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_trust_window_revoke_desc = /** @type {((inputs: Audit_Details_Trust_Window_Revoke_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Trust_Window_Revoke_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ein Vertrauensfenster für Werkzeuge wurde geschlossen (${i?.scope}). Passende Werkzeugaufrufe fragen wieder nach einer Bestätigung.`)
	return /** @type {LocalizedString} */ (`A tool trust window was closed (${i?.scope}), so matching tool calls ask for confirmation again.`)
});